import { UcoastEl } from '@/scripts/core/UcoastEl'
import {type KlaviyoPopup} from "@/scripts/theme/klaviyo-popup";
import {
    formatPhoneNumber,
    getOrThrow,
    getOrUndefined,
    qsOptional,
    qsRequired
} from "@/scripts/core/global";

export class KlaviyoForm extends UcoastEl {
    static htmlSelector = 'klaviyo-form'
    form: HTMLFormElement
    submitButton: HTMLButtonElement
    emailInput: HTMLInputElement
    successMessage: string
    route: string
    popup?: KlaviyoPopup

    constructor() {
        super()
        this.form = qsRequired('form', this)
        this.submitButton = qsRequired('[type="submit"]', this)
        this.emailInput = qsRequired('[type="email"]', this)
        this.successMessage = this.getSuccessMessage()
        this.route = `https://a.klaviyo.com/client/subscriptions/?company_id=PTtQzt`
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.popup = qsOptional<KlaviyoPopup>('klaviyo-popup', this)
    }

    getSuccessMessage(): string {
        const message = this.form.getAttribute('data-success')
        return message ?? 'Thank You'
    }

    renderSuccess() {
        this.emailInput.value = ''
        this.emailInput.placeholder = this.successMessage
        if (this.popup) {
            window.setTimeout(() => {
                this.popup?.hide()
            }, 5000)
        }
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')
    }

    renderError() {
        this.emailInput.value = ''
        this.emailInput.placeholder = 'This email address is invalid.'
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-disabled')
    }

    onSubmitHandler(event: Event) {
        event.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return
        if (this.emailInput.value.length < 1) {
            this.renderError()
        }

        this.submitButton.setAttribute('aria-disabled', 'true')
        this.submitButton.classList.add('loading')

        const formData = new FormData(this.form)

        const config = this.addToKlaviyoListConfig(formData)

        fetch(this.route, config)
            .then((response) => response.text())
            .then((response) => {

                if (response?.length) {
                    this.renderError()
                    return
                }
                this.renderSuccess()
            })
            .catch((e) => {
                this.renderError()
                console.error(e)
            })
    }
    addToKlaviyoListConfig(body: FormData) {
        const values = {
            email: getOrThrow(body, 'email'),
            list_id: getOrThrow(body, 'list_id'),
            phone_number: getOrUndefined(body, 'phone_number'),
        }
        if (values.phone_number) {
            values.phone_number = formatPhoneNumber(values.phone_number)
        }
        return {
            method: 'POST',
            mode: 'cors' as RequestMode,
            headers: {
                'Content-Type': 'application/json',
                Revision: '2024-05-15',
            },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: values.email,
                                    phone_number: values.phone_number
                                },
                            },
                        },
                    },
                    relationships: {
                        list: {
                            data: {
                                type: 'list',
                                id: values.list_id,
                            },
                        },
                    },
                },
            }),
        }
    }
}
